import { useState } from 'react'
import { Alert, Button, Spinner, Stack } from 'react-bootstrap'
import { useMutation, useQueryClient } from 'react-query'
import { publishAgent } from '../../api/agent';
import { IAgent } from '../../models/agent';
import { useOrgContext } from '../../context/org';
import { useParams } from 'react-router-dom';

type Props = {
	agent: IAgent,
}

function PublishAgent({agent} : Props) {
	// const [renewkey, setRenewkey] = useState(agent.isPublished || false);
	const [error, setError] = useState("");

	const {orgId} = useParams();
	const {membership} = useOrgContext();
	const allowed = ["owner", "admin", "editor"]
	const permission = !allowed.includes(membership?.role || "");

	// published mutations
	const query = useQueryClient();
	const {mutateAsync: publishAgenFn, isLoading} = useMutation({
		mutationKey: 'published',
		mutationFn: publishAgent,
		onSuccess: () => {
			query.invalidateQueries(["Agents", agent.organizationId]);
		},
		onError: (error: any) => {
			setError( "Failed to published agent. Please try again or contact admin.");
		}
	})

	const handlePublishAgent = () => {
		if(!orgId) {
			setError("Organization not found.");
			return;
		}
		publishAgenFn({orgId, id: agent.id})
	}

  return (
	<Stack>
		<div>
			{
				!agent.isPublished ? (<>
					<h2>Publish Agent</h2>
					<p>The agent must be published before deployment</p>
				</>) : (
					<h2>Renerate Access Key</h2>
				)
			}
			{/* {agent.accessKey &&
			<Form.Group  className="mb-3 mt-3">
				<Form.Label muted>
					Regenerating the access key requires re-deployment of the agent.
				</Form.Label>
				<Form.Check
					type="switch"
					id="custom-switch"
					label="Regenerate Access Key"
					checked={renewkey}
					onChange={() => setRenewkey(!renewkey)}
				/>
			</Form.Group>
			} */}
			<Button 
				disabled={permission}
				className={`${permission ? 'disabledCursor' : ""}`}
				onClick={handlePublishAgent}>
				{isLoading && <Spinner/>} {agent.isPublished ? "Renerate" : "Publish"}
			</Button>
		</div>
		{error && (
			<Alert variant="danger" className="mt-3">
				{error}
			</Alert>
		)}
	</Stack>
  )
}

export default PublishAgent